module.exports = __webpack_public_path__ + "img/tip3.83613fff.png";